import { useEffect, useContext } from 'react'
import { AuthContext } from '../contexts/auth/authContext'

export default function UserManual() {
    const auth = useContext(AuthContext)
    useEffect(()=>{
        auth?.openPdf('/pdf/May_2024_SZ_ModularBatterySystem_QuickReferenceGuide_V1.pdf') 
    },[])

    return null;
}